export default "/images/vendor/@coreui/icons/svg/flag/cif-bn.svg?272de14e273b27c49f1b632224132f58";